import React, { useEffect, useState } from "react";
import {
  LandingNav, HeroSection, StatsStrip, FeaturesSection, HowItWorksSection, FinalCTA, LandingFooter,
} from "@/components/landing/LandingSections";

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background text-white" data-testid="landing-root">
      <LandingNav scrolled={scrolled} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <HeroSection />
      <StatsStrip />
      <FeaturesSection />
      <HowItWorksSection />
      <FinalCTA />
      <LandingFooter />
    </div>
  );
}
